// Grammar & usage reference — the core Standard English Conventions rules,
// reproduced in full and highlightable. Paragraphs are plain strings or
// structured blocks { type: 'list', items: [...] } — list blocks render as a
// bulleted list instead of one run-on sentence.

export const documentTitle = 'Grammar & Usage Reference';
export const documentSlug = 'grammar-reference';

export const parts = [
  {
    id: 'grammar-reference-full',
    title: null,
    sections: [
      {
        id: 'subject-verb-agreement',
        heading: 'Subject-Verb Agreement',
        paragraphs: [
          {
            type: 'list',
            items: [
              'A verb must agree in number with its subject: singular subjects take singular verbs, plural subjects take plural verbs.',
              'Watch for phrases between the subject and verb — words like "along with," "as well as," and "in addition to" do not change the number of the subject.',
              'Compound subjects joined by "and" are plural and take a plural verb.',
              'Subjects joined by "or" or "nor" agree with the closer subject.',
            ],
          },
        ],
      },
      {
        id: 'punctuation-commas',
        heading: 'Commas with Nonessential Information',
        paragraphs: [
          'Nonessential clauses and phrases — extra information that could be removed without changing the sentence\'s core meaning — must be set off with a pair of commas. Essential (restrictive) clauses, which are necessary to identify what\'s being talked about, take no commas.',
        ],
      },
      {
        id: 'sentence-boundaries',
        heading: 'Sentence Boundaries',
        paragraphs: [
          'Two independent clauses may be joined with:',
          {
            type: 'list',
            items: [
              'A comma and a coordinating conjunction (for, and, nor, but, or, yet, so)',
              'A semicolon',
              'A period',
            ],
          },
          'Never a comma alone (a "comma splice") and never no punctuation at all (a "run-on").',
        ],
      },
      {
        id: 'apostrophes',
        heading: 'Apostrophes and Possessives',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Use an apostrophe + s to show singular possession ("the student\'s notebook").',
              'Use just an apostrophe after the s for plural possession ("the students\' notebooks").',
              'Do not use an apostrophe to form an ordinary plural.',
            ],
          },
        ],
      },
      {
        id: 'pronoun-antecedent',
        heading: 'Pronoun-Antecedent Agreement',
        paragraphs: [
          'A pronoun must agree in number and person with the noun it refers to. If the noun it replaces is singular, the pronoun must be singular ("Each student submitted their essay" is a mismatch of formal number agreement in strict usage — "his or her" or restructuring to a plural subject avoids the ambiguity).',
        ],
      },
      {
        id: 'modifier-placement',
        heading: 'Modifier Placement',
        paragraphs: [
          'A modifying word, phrase, or clause should be placed as close as possible to the word it describes. A "dangling modifier" — one with no clear word to modify at the start of a sentence — creates an unintended or illogical meaning.',
        ],
      },
      {
        id: 'parallel-structure',
        heading: 'Parallel Structure',
        paragraphs: [
          'Items in a list or comparison should use the same grammatical form. For example, "She enjoys hiking, swimming, and to bike" breaks parallelism; "hiking, swimming, and biking" fixes it.',
        ],
      },
    ],
  },
];
